import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { BodyMessage, ButtonContainer, HeaderModal, ModalBox } from './styles';
import { RequestModalProps } from './types';

const RequestModal: React.FC<RequestModalProps> = ({
    title = 'Solicitud enviada',
    description = 'Tu solicitud de reservación ha sido solicitada exitosamente, a continuación será revisada por un administrador. En breve te notificaremos el status de tu reserva.',
    onClose,
    onCancel,
    onConfirm,
    type = 'info'
}) => {
    const [open, setOpen] = React.useState(true);
    // const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        onClose && onClose();
    };

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <ModalBox>
                        <HeaderModal>
                            {title}
                        </HeaderModal>
                        <BodyMessage>
                            {description}
                        </BodyMessage>
                        <ButtonContainer>
                            {
                                type === 'verify' &&
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: '100%',
                                        borderRadius: '12px',
                                        fontSize: '18px',
                                        backgroundColor: '#13314D',
                                        color: '#FFFFFF',
                                        textTransform: 'none',
                                        '&:hover': {
                                            // backgroundColor: theme.color.sheen,
                                        }
                                    }}
                                    onClick={() => {
                                        handleClose();
                                        onCancel && onCancel();
                                    }}
                                >
                                    Cancelar
                                </Button>
                            }
                            <Button
                                variant="contained"
                                sx={{
                                    width: '100%',
                                    borderRadius: '12px',
                                    fontSize: '18px',
                                    backgroundColor: '#13314D',
                                    color: '#FFFFFF',
                                    textTransform: 'none',
                                    '&:hover': {
                                        // backgroundColor: theme.color.sheen,
                                    }
                                }}
                                onClick={() => {
                                    handleClose();
                                    onConfirm && onConfirm();
                                }}
                            >
                                Aceptar
                            </Button>
                        </ButtonContainer>
                    </ModalBox>
                </Fade>
            </Modal>
        </div>
    );
}

export default RequestModal;